import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"


export default /*#__PURE__*/_defineComponent({
  __name: 'pc-module-sub-title-5',
  props: {
    innerText: { default: '大标题' },
    index: {}
  },
  setup(__props: any) {

const props = __props;

const svg = `
<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="100%" height="40" viewBox="0 0 1024 45">
  <defs>
    <linearGradient id="linear-gradient" y1="-0.159" x2="0.5" y2="0.667" gradientUnits="objectBoundingBox">
      <stop offset="0" stop-color="var(--theme-color-1)"/>
      <stop offset="1" stop-color="#fff"/>
    </linearGradient>
  </defs>
  <g id="xiaobiao5" transform="translate(0 -1)">
    <circle id="椭圆_825" data-name="椭圆 825" cx="22.5" cy="22.5" r="22.5" transform="translate(0 1)" fill="url(#linear-gradient)"/>
    <text id="项目执行人性别分布" transform="translate(16 36)" fill="#222" font-size="22" font-weight="600" letter-spacing="0.09em"><tspan x="0" y="0">${props.innerText}</tspan></text>
  </g>
</svg>
`;

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: "svg-block",
    innerHTML: svg
  }))
}
}

})